import Avatar1 from "@/assets/images/HeroStats/Avatar1.png";
import Avatar2 from "@/assets/images/HeroStats/Avatar2.png";
import Avatar3 from "@/assets/images/HeroStats/Avatar3.png";
import OtherOfferingChatCommunity from "@/assets/images/OtherOfferings/features-chat-community.svg";
import OtherOfferingEmail from "@/assets/images/OtherOfferings/features-mail.svg";
import OtherOfferingMarketing from "@/assets/images/OtherOfferings/features-marketing-&-sales-tools.svg";
import OtherOfferingMarketingAutomations from "@/assets/images/OtherOfferings/features-marketing-automations.svg";
import OtherOfferingMobileApp from "@/assets/images/OtherOfferings/features-mobile-app.svg";
import OtherOfferingMostSecurePlatform from "@/assets/images/OtherOfferings/features-most-secure-platform.svg";
import OtherOfferingPaymentGateways from "@/assets/images/OtherOfferings/features-payment-gateways.svg";
import OtherOfferingThirdPartyIntegrations from "@/assets/images/OtherOfferings/features-third-party-integrations.svg";
import OtherOfferingWebsiteBuilder from "@/assets/images/OtherOfferings/features-website-builder.svg";
import { FeatureCTASectionPropType } from "@/components/Features/FeatureCTASection";
import { FeatureCardsSectionPropType } from "@/components/Features/FeatureCardsSection";
import { FeatureHeroSectionPropType } from "@/components/Features/FeatureHeroSection";
import { ButtonSizeEnum, ButtonTypeEnum } from "@/components/atoms/Button";

import {
  BookADemoSourceEnum,
  CtaActionType,
  SignUpSourceEnum,
} from "@/components/molecules/CtaButtonGroup";
import { SuccessStoriesMarqueeSectionPropType } from "@/components/organisms/Carousels/SuccessStoriesMarqueeSection";
import { FaqSectionPropsType } from "@/components/organisms/FaqSection";
import {
  InfoAccFeatSecForAmpEnum,
  InfoAccordionProps,
  InfoAccordionTypeEnum,
} from "@/components/organisms/InfoAccordion/InfoAccordion";
import {
  OtherOfferingsMetaDataType,
  OtherOfferingsSectionPropType,
} from "@/components/organisms/OtherOfferingsSection";

import BannerAiAgent from "@/assets/images/Features/Cards/Webiste_AI Agent_Hero Banner.png";
import BannerAiBrain from "@/assets/images/Features/Cards/Website_builder_AIbrain.png";
// HeroBanners Assets:
import BannerChatCommunity from "@/assets/images/Features/HeroBanners/chat-community.png";
import BannerIntegratePaymentGateway from "@/assets/images/Features/HeroBanners/integrate-payment-gateway.png";
import BannerMarketingTools from "@/assets/images/Features/HeroBanners/marketing-tools.png";
import BannerMobileApp from "@/assets/images/Features/HeroBanners/mobile-app.png";
import BannerSecureVideoStreaming from "@/assets/images/Features/HeroBanners/secure-video-streaming.png";
import BannerThirdPartySupport from "@/assets/images/Features/HeroBanners/third-party-support.png";
import BannerWebsiteBuilder from "@/assets/images/Features/HeroBanners/website-builder.png";

// FeatureCards assets:
import CardsWebsiteBuilder1 from "@/assets/images/Features/Cards/website-builder/1.svg";
import CardsWebsiteBuilder2 from "@/assets/images/Features/Cards/website-builder/2.svg";
import CardsWebsiteBuilder3 from "@/assets/images/Features/Cards/website-builder/3.svg";

import CardsMobileApp1 from "@/assets/images/Features/Cards/mobile-app/1.svg";
import CardsMobileApp2 from "@/assets/images/Features/Cards/mobile-app/2.svg";
import CardsMobileApp3 from "@/assets/images/Features/Cards/mobile-app/3.svg";

import CardsMarketingTools1 from "@/assets/images/Features/Cards/marketing-tools/1.svg";
import CardsMarketingTools2 from "@/assets/images/Features/Cards/marketing-tools/2.svg";
import CardsMarketingTools3 from "@/assets/images/Features/Cards/marketing-tools/3.svg";

import CardsChatCommunity1 from "@/assets/images/Features/Cards/chat-community/1.svg";
import CardsChatCommunity2 from "@/assets/images/Features/Cards/chat-community/2.svg";
import CardsChatCommunity3 from "@/assets/images/Features/Cards/chat-community/3.svg";

import CardsIntegratePaymentGateway1 from "@/assets/images/Features/Cards/integrate-payment-gateway/1.svg";
import CardsIntegratePaymentGateway2 from "@/assets/images/Features/Cards/integrate-payment-gateway/2.svg";
import CardsIntegratePaymentGateway3 from "@/assets/images/Features/Cards/integrate-payment-gateway/3.svg";

import CardsThirdPartySupport1 from "@/assets/images/Features/Cards/third-party-support/1.svg";
import CardsThirdPartySupport2 from "@/assets/images/Features/Cards/third-party-support/2.svg";
import CardsThirdPartySupport3 from "@/assets/images/Features/Cards/third-party-support/3.svg";

import CardsSecureVideoStreaming1 from "@/assets/images/Features/Cards/secure-video-streaming/1.svg";
import CardsSecureVideoStreaming2 from "@/assets/images/Features/Cards/secure-video-streaming/2.svg";
import CardsSecureVideoStreaming3 from "@/assets/images/Features/Cards/secure-video-streaming/3.svg";

// InfoAccordion assets:
import InfoAccordionChatCommunity from "@/assets/images/Features/InfoAccordion/chat-community/common.png";
import InfoAccordionIntegratePaymentGateway from "@/assets/images/Features/InfoAccordion/integrate-payment-gateway/common.png";
import InfoAccordionMarketingTools from "@/assets/images/Features/InfoAccordion/marketing-tools/common.png";
import InfoAccordionMobileApp from "@/assets/images/Features/InfoAccordion/mobile-app/common.png";
import InfoAccordionSecureVideoStreaming from "@/assets/images/Features/InfoAccordion/secure-video-streaming/common.png";
import InfoAccordionThirdPartySupport from "@/assets/images/Features/InfoAccordion/third-party-support/common.png";
import InfoAccordionWebsiteBuilder from "@/assets/images/Features/InfoAccordion/website-builder/common.png";

import { TestimonyCarouselSectionPropType } from "@/components/organisms/Carousels/TestimonyCarouselSection";
import { GraphyHeadPropType } from "@/components/organisms/GraphyHead";
import { LANDING_PAGE_EVENTS } from "@/constants/amplitude.constants";
import { CtaVisitHelpCentre_en } from "../constants/common.constants";
import { FeaturePageSlugEnum, OnboardingDestinationEnum } from "../types/common.types";
import { FeaturesEnum_en, HeroPillCategoryEnum_en } from "./hero-pills.data";
import { ROUTE_PATHS } from "./routes";

import CardsAiAgent1 from "@/assets/images/Features/Cards/graphy-assist/1.png";
import CardsAiAgent2 from "@/assets/images/Features/Cards/graphy-assist/2.png";
import CardsAiAgent3 from "@/assets/images/Features/Cards/graphy-assist/3.png";
import CardsAiBrain1 from "@/assets/images/Features/Cards/graphy-assist/brain_card1.png";
import CardsAiBrain3 from "@/assets/images/Features/Cards/graphy-assist/brain_card2.png";
import CardsAiBrain2 from "@/assets/images/Features/Cards/graphy-assist/brain_card3.png";
import agentWorks1 from "@/assets/images/Products/InfoAccordion/agentworks-1.png";
import agentWorks2 from "@/assets/images/Products/InfoAccordion/agentworks-2.png";
import agentWorks3 from "@/assets/images/Products/InfoAccordion/agentworks-3.png";
import agentWorks4 from "@/assets/images/Products/InfoAccordion/agentworks-4.png";
import aibraininfoaccordian1 from "@/assets/images/Products/InfoAccordion/aibraininfoaccordian-1.png";
import aibraininfoaccordian2 from "@/assets/images/Products/InfoAccordion/aibraininfoaccordian-2.png";
import aibraininfoaccordian3 from "@/assets/images/Products/InfoAccordion/aibraininfoaccordian-3.png";
import aibraininfoaccordian4 from "@/assets/images/Products/InfoAccordion/aibraininfoaccordian-4.png";


export type FeaturePageDataType = {
  seoMeta: GraphyHeadPropType;
  otherOfferingsMeta: OtherOfferingsMetaDataType;
  featureHeroSectionProps: FeatureHeroSectionPropType;
  testimonyCarouselSectionProps: TestimonyCarouselSectionPropType;
  featureCardsSectionProps: FeatureCardsSectionPropType;
  infoAccordionSection: InfoAccordionProps;
  successStoriesMarqueeSectionProps: SuccessStoriesMarqueeSectionPropType;
  faqSectionProps: FaqSectionPropsType;
  featureCTASectionProps: FeatureCTASectionPropType;
};

export const otherFeatureOfferingsSectionProps_en: OtherOfferingsSectionPropType =
  {
    otherOfferingsMetaData: [],
    title: [
      {
        text: "Check Out Offerings That Will Help You Grow",
      },
    ],
    gap: "gap-4 sm:gap-9",
  };

const WebsiteBuilderPageData: FeaturePageDataType = {
  seoMeta: {
    title: "No code website builder for creators - Graphy",
    description: "Create your own website and host it on your custom domain. Free website hosting and generation for creators. Make your website now.",
    canonicalPath: ROUTE_PATHS.FEATURES.WebsiteBuilder,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Website Builder",
    description:
      "Take your online presence to new heights with our intuitive website builder",
    image: OtherOfferingWebsiteBuilder,
    slug: FeaturePageSlugEnum.WebsiteBuilder,
    path: ROUTE_PATHS.FEATURES.WebsiteBuilder,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.WebsiteBuilder,
    },
    title: [
      {
        text: "No code?",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "no problem",
      },
    ],
    description:
      "Take your online presence to new heights with our intuitive website builder",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create website",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "150,000+ creators have their websites live",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerWebsiteBuilder,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Get a ",
      },
      {
        text: "free website",
        highlight: true,
      },
      {
        text: " in just 5 minutes",
        highlight: false,
      },
    ],
    description:
      "With Graphy, easily connect all aspects of your online content through a beautifully created website",
    steps: [
      {
        text: "Website of your own",
        description:
          "Get the perfect online home for your courses, digital products, webinars on onboarding",
        image: CardsWebsiteBuilder1,
      },
      {
        text: "Customise based on your brand",
        description:
          "Personalize your website without any technical or design skills with our no-code editor",
        image: CardsWebsiteBuilder2,
      },
      {
        text: "Your online digital store",
        description:
          "Focus on content, while we consolidate your online business under one website",
        image: CardsWebsiteBuilder3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Build your website",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Websitebuilder,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Create website",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionWebsiteBuilder, alt: "" },
    data: [
      {
        title: "Free branded website",
        description:
          "Get a beautiful website once you signup, which can be customised based on your brand",
      },
      {
        title: "Your own digital store",
        description:
          "Sell your courses, webinars, digital products, memberships in an all-in-one website hassle free.",
      },
      {
        title: "Mobile-responsive design",
        description:
          "Reach your audience everywhere with our mobile-responsive design",
      },
      {
        title: "Your website, your domain",
        description:
          "Use your own domain name or select from Graphy’s free domains",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Do I need prior expertise to create my website",
        answer:
          "No, your website is created automatically when you signup on the platform.",
      },
      {
        question: "Can I edit my website built on Graphy?",
        answer:
          "We offer limited customisation options on our website builder that caters to thousands of creators. However, major overhaul and layout changes will not be possible.",
      },
      {
        question: "Will my website be available for mobile users?",
        answer:
          "Yes, your Graphy website will be optimized for mobile screens and other responsive screens.",
      },
      {
        question: "Will my website comply with all the privacy related laws?",
        answer:
          "Yes your Graphy website will be optimized according to your local privacy laws. We also offer configurations to customise for international user base.",
      },
      {
        question: "Are all the website pages optimized for SEO?",
        answer:
          "Yes, every public page generated on your Graphy website will be optimized for SEO.",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Let's build your",
        highlight: false,
      },
      {
        text: " customised website",
        highlight: true,
      },
    ],
    description:
      "Take your online presence to new heights with our intuitive website builder",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Start for free",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const MobileAppPageData: FeaturePageDataType = {
  seoMeta: {
    title: "No code mobile apps for creators - Graphy",
    description: "Create your custom mobile app and publish your app on Play Store. Easy mobile app builder for your audince to access your content on the go.",
    canonicalPath: ROUTE_PATHS.FEATURES.MobileApp,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Mobile App",
    description:
      "Get a pre-built mobile app that will captivate your customers",
    image: OtherOfferingMobileApp,
    slug: FeaturePageSlugEnum.MobileApp,
    path: ROUTE_PATHS.FEATURES.MobileApp,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.MobileApp,
    },
    title: [
      {
        text: "Branded",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "mobile app",
      },
    ],
    description:
      "Get a pre-built mobile app that will captivate your customers.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get your app",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "10,000+ creators created their app",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerMobileApp,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Get your own ",
      },
      {
        text: "branded app",
        highlight: true,
      },
      {
        text: " within minutes",
        highlight: false,
      },
    ],
    description:
      "With Graphy, easily get a ready made app which your learners can access on the go.",
    steps: [
      {
        text: "Branded app of your own",
        description:
          "Rise above your competition with our sleek, professional-grade app",
        image: CardsMobileApp1,
      },
      {
        text: "No development cost involved",
        description:
          "With no development effort, get your android and iOS apps* readily available",
        image: CardsMobileApp2,
      },
      {
        text: "Learning on the go",
        description:
          "Empower your learners to access your content through your mobile app.",
        image: CardsMobileApp3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Make your own app without coding",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Mobileapp,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Get your app",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: {
      src: InfoAccordionMobileApp,
      alt: "",
    },
    data: [
      {
        title: "Exclusively yours",
        description:
          "With no effort, get a branded app of your own on both android and iOS *",
      },
      {
        title: "No-code, No-maintenance",
        description: "No more development or maintenance costs on your end.",
      },
      {
        title: "Learning on the go",
        description:
          "Boost your learners’ engagement and motivation by providing exceptional learning experience",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Are iOS apps* also available?",
        answer: "Yes, we will also create your iOS app",
      },
      {
        question:
          "Do I need any prior app development experience for making apps?",
        answer:
          "No, we will create the apps for you as per your requirement. You will just be required to provide us with the proper configuration details for Play Store and App Store",
      },
      {
        question:
          "Will the apps be published under Graphy account on Play Store?",
        answer:
          "No, your apps will be published under your Play Store and App Store account. We will need configuration details that will help us automate the app creation process.",
      },
      {
        question: "How much time does it take to get an app?",
        answer:
          "It takes around 2-3 days to publish an Android app and around 7 days to publish an iOS app",
      },
      {
        question:
          "Is there a limit on the number of users I can have on the app?",
        answer: "No, you can have unlimited users on the mobile apps",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Get an app",
        highlight: false,
      },
      {
        text: " you can call your own",
        highlight: true,
      },
    ],
    description:
      "Get a pre-built mobile app that will captivate your customers.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get your app",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const MarketingToolsPageData: FeaturePageDataType = {
  seoMeta: {
    title: "Automated marketing funnels, campains and affiliate system for creators - Graphy",
    description: "Convert your audience better with inbuilt marketing automations, affiliates infrastructure and much more.",
    canonicalPath: ROUTE_PATHS.FEATURES.MarketingTools,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Marketing Tools",
    description:
      "Graphy's marketing tools helps you capture more leads & scale your knowledge business",
    image: OtherOfferingMarketingAutomations,
    slug: FeaturePageSlugEnum.MarketingTools,
    path: ROUTE_PATHS.FEATURES.MarketingTools,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.MarketingTools,
    },
    title: [
      {
        text: "Capture &",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "convert",
      },
    ],
    description:
      "Graphy's marketing tools helps you capture more leads & scale your knowledge business",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Start scaling",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "150,000+ creators have benefitted",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerMarketingTools,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Supercharge your ",
      },
      {
        text: "marketing",
        highlight: true,
      },
      {
        text: " funnels",
        highlight: false,
      },
    ],
    description:
      "Unlease the power of Graphy's integrated marketing tools to grow your business exponentially",
    steps: [
      {
        text: "Targeted traffic generation",
        description:
          "Drive qualified traffic to your courses and skyrocket your sales with SEO optimized website",
        image: CardsMarketingTools1,
      },
      {
        text: "Automated campaigns",
        description:
          "Maximise conversions with automated and drip emails and whatsapp for multiple usecases",
        image: CardsMarketingTools2,
      },
      {
        text: "Referral & affiliate programs",
        description:
          "Expand your reach and increase sales with referral and affiliate programs.",
        image: CardsMarketingTools3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Optimise conversions",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Marketingtools,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Start scaling",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionMarketingTools, alt: "" },
    data: [
      {
        title: "Automated campaigns",
        description:
          "Never miss a potential buyer with the right set of communications across different steps of the purchase funnel",
      },
      {
        title: "Referral marketing",
        description:
          "Harness the power of word-of-mouth marketing with a referral program that rewards your learners.",
      },
      {
        title: "Optimized for SEO",
        description:
          "Optimize your course website and landing pages using otherOfferingsMeta tags, keywords, and clean HTML code.",
      },
      {
        title: "Flexible promotions",
        description:
          "Offer promotions and discounts to attract more learners and increase sales.",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question: "Can I send custom notifications to my audience?",
        answer:
          "Yes, you will be able to send custom notifications to your audience. You can also filter them out on the basis of some parameters.",
      },
      {
        question: "Who will be these communications sent from?",
        answer: "All the communications will be sent on behalf of your Graphy",
      },
      {
        question:
          "Can I control when and to whom these marketing communications will be sent?",
        answer:
          "Yes, you can control the delivery and audience of your marketing campaign.",
      },
      {
        question: "Can I customise my on-page SEO?",
        answer:
          "Yes, you can customise your on-page SEO to certain level inlcuding adding custom tags, otherOfferingsMeta information, etc.",
      },
      {
        question: "Are there any extra charges to run an affiliate network?",
        answer: "No, there are no extra charges to run an affiliate network",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Let's get",
        highlight: false,
      },
      {
        text: " started today",
        highlight: true,
      },
    ],
    description:
      "Graphy helps you capture more leads and scale your knowledge business with various marketing tools",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Start scaling",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const ChatCommunityPageData: FeaturePageDataType = {
  seoMeta: {
    title: "Build, Manage & Monetize Your Community → Graphy",
    description:
      "Launch a branded community connected to your courses, memberships, and products. Own your audience and engagement with Graphy.",
    canonicalPath: ROUTE_PATHS.FEATURES.ChatCommunity,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "Chat Community",
    description: "Boost member retention through engaging chat interactions",
    image: OtherOfferingChatCommunity,
    slug: FeaturePageSlugEnum.ChatCommunity,
    path: ROUTE_PATHS.FEATURES.ChatCommunity,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.ChatCommunity,
    },
    title: [
      {
        text: "Elevate your",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "interactions",
      },
    ],
    description: "Boost member retention through engaging chat interactions.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get started",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "1,000,000+ messages exchanged",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerChatCommunity,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Create, engage & grow ",
        highlight: true,
      },
      {
        text: " your community",
        highlight: false,
      },
    ],
    description:
      "Behind every successful course is a loyal community who loves to learn, grow & engage with each other",
    steps: [
      {
        text: "Forums for your learners",
        description:
          "Launch paid or free communities for members to enrol and engage.",
        image: CardsChatCommunity1,
      },
      {
        text: "Direct communication with learners",
        description:
          "Your learners can communicate with you and resolve their queries directly.",
        image: CardsChatCommunity2,
      },
      {
        text: "Multimedia conversations",
        description:
          "Whether you want to post a video, image, or text, it's all supported.",
        image: CardsChatCommunity3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Build your own community",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Chatcommunity,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Get started",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionChatCommunity, alt: "" },
    data: [
      {
        title: "Launch your forum",
        description:
          "Keep your learners engaged in public forums, they'll eventually turn into paid learners.",
      },
      {
        title: "Create your inner circle",
        description:
          "Keep a private discussion forum for all your paid learners. They can share their progress, ask doubts, and celebrate small wins.",
      },
      {
        title: "Verified profiles",
        description:
          "Admins and instructors get blue tick profiles. This helps in building authenticity within the community",
      },
      {
        title: "Course-wise discussion",
        description:
          "Make important course-wise announcements and share recent updates.",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "Will the audience be notified of the happenings in community?",
        answer:
          "Yes, we have configured automated notifications at all the primary events",
      },
      {
        question: "Is community available on Android and iOS apps* too?",
        answer:
          "Yes, all the functionalities of community are available to the audience on Andoid and iOS apps*",
      },
      {
        question:
          "Is there any limit on the number of channels and members I can have in the community",
        answer:
          "No, you can create unlimited channels, have unlimited members and send unlimited messages",
      },
      {
        question: "Can I create a paid community?",
        answer:
          "You can have a separate community under your membership that can act as a paid community",
      },
      {
        question: "Can I upload images/ videos in community channels?",
        answer:
          "Yes, you can upload unlimited photos and videos in community channels",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Start interacting",
        highlight: true,
      },
      {
        text: " with your learners",
        highlight: false,
      },
    ],
    description: "Boost member retention through engaging chat interactions.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Start for free",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const SecureVideoStreamingPageData: FeaturePageDataType = {
  seoMeta: {
    title: "Secure your content with customized DRM and more - Graphy",
    description: "Prevent duplication of your content and make sure your content is not being resold with Graphy's custom DRM.",
    canonicalPath: ROUTE_PATHS.FEATURES.SecureVideoStreaming,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Most Secure Platform",
    description:
      "Get top-notch security to protect your content from piracy and unauthorized access.",
    image: OtherOfferingMostSecurePlatform,
    slug: FeaturePageSlugEnum.SecureVideoStreaming,
    path: ROUTE_PATHS.FEATURES.SecureVideoStreaming,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.MostSecurePlatform,
    },
    title: [
      {
        text: "Best content",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "best security",
      },
    ],
    description:
      "Get top-notch security to protect your content from piracy and unauthorized access.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get started now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "150,000+ creators trust Graphy's secured platform",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerSecureVideoStreaming,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "No piracy, ",
      },
      {
        text: "no revenue loss",
        highlight: true,
      },
    ],
    description: "Boost your sales 10x by securing your course content",
    steps: [
      {
        text: "Privacy at its core",
        description:
          "Get the perfect online home for your courses, digital products & for your brand on onboarding",
        image: CardsSecureVideoStreaming1,
      },
      {
        text: "100% secure mobile apps",
        description:
          "Secure mobile apps with offline access and piracy prevention.",
        image: CardsSecureVideoStreaming2,
      },
      {
        text: "Promote course",
        description:
          "Secure videos with concurrency control, dynamic watermarking, and more",
        image: CardsSecureVideoStreaming3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Get started with the most secured platform",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Mostsecureplatform,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Start for free",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionSecureVideoStreaming, alt: "" },
    data: [
      {
        title: "Robust content security",
        description:
          "Safeguard your content with login authentication, encryption, DRM, and token protection to control access.",
      },
      {
        title: "Device restrictions",
        description:
          "Prevent misuse by limiting the number of devices accessing the platform and maintaining control.",
      },
      {
        title: "Secure video streaming",
        description:
          "Protect your videos with no streaming concurrency, dynamic watermarking, content validity, and non-downloadable formats.",
      },
      {
        title: "Anti-screen recording",
        description:
          "Prevent unauthorized screen recording or mirroring of your content to eliminate piracy risks.",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "Are there any extra costs associated with security features?",
        answer: "No, there are no extra costs for security features",
      },
      {
        question: "Can I turn off security features on my platform?",
        answer:
          "Yes, we have configurations to turn off specific security features",
      },
      {
        question: "Do you have DRM integrated on the platform?",
        answer:
          "We have support for custom DRM, but currently we do not support browser integrated DRM",
      },
      {
        question: "Is there any limit on these security features?",
        answer: "No, there are no limits associated with security features",
      },
      {
        question: "Do you provide security features for PDFs too?",
        answer:
          "We provide watermarking for PDFs to prevent direct duplication of content",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Leave security to us,",
        highlight: false,
      },
      {
        text: " you start selling",
        highlight: true,
      },
    ],
    description:
      "Get top-notch security to protect your content from piracy and unauthorized access.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get started now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const IntegratePaymentGatewayPageData: FeaturePageDataType = {
  seoMeta: {
    title: "Receive payments for your content with inbuilt payment gateways - Graphy",
    description: "Activate your payment gateway within in minutes | Support for international payments | Start selling on Graphy now",
    canonicalPath: ROUTE_PATHS.FEATURES.IntegratePaymentGateway,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Integrated Payment Gateways",
    description:
      "Activate your payments in one click and collect $ from your sales in no time.",
    image: OtherOfferingPaymentGateways,
    slug: FeaturePageSlugEnum.IntegratePaymentGateway,
    path: ROUTE_PATHS.FEATURES.IntegratePaymentGateway,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.PaymentGateways,
    },
    title: [
      {
        text: "Simple, swift",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "payments",
      },
    ],
    description:
      "Activate your payments in one click and collect $ from your sales in no time.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get paid now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "5000+ million earned by creators",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerIntegratePaymentGateway,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Seamless payments",
        highlight: true,
      },
      {
        text: " for better conversions",
        highlight: false,
      },
    ],
    description:
      "Expand your reach, boost sales, and conquer global markets with ease",
    steps: [
      {
        text: "Multiple payment options",
        description:
          "Optimized for creators across the globe so you can start and grow from and to anywhere ",
        image: CardsIntegratePaymentGateway1,
      },
      {
        text: "Set country-specific pricing",
        description:
          "Price your content according to your audience and collect payments in the same currency.",
        image: CardsIntegratePaymentGateway2,
      },
      {
        text: "Promo codes and discounts",
        description:
          "Give special discounts for a limited time or only to specific audiences.",
        image: CardsIntegratePaymentGateway3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Hassle free payment integrations",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Integratedpaymentgateways,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Get paid now",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionIntegratePaymentGateway, alt: "" },
    data: [
      {
        title: "5-star payments suite",
        description:
          "At Graphy we support UPI, debit cards, credit cards, net banking, and wallets. For international creators, we’re integrated with both Stripe and PayPal.",
      },
      {
        title: "Optimized checkout",
        description:
          "Encourage your learners to purchase with customizable conversion-optimized checkout pages.",
      },
      {
        title: "Hook them with trial offers",
        description:
          "You can offer free trials for your courses or charge partially for that time period. Your choice.",
      },
      {
        title: "Billing & invoicing",
        description:
          "Customize your invoice, incorporate tax, and automatically send it after each transaction.",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "What all information do I need to provide to integrate a payment gateway?",
        answer:
          "As mandated by the government, you will need to provide details of certain KYC documents like PAN, as per your country. Apart from that we will also need your bank account details to deposit your earnings.",
      },
      {
        question: "How much time does it take to integrate the payment gateway",
        answer:
          "After providing the required details it takes 2-3 minutes to get your payment gateway activated",
      },
      {
        question: "Can I use my own payment gateway on Graphy?",
        answer:
          "If you have set up your payment gateway already, we provide you with an option to connect your account with Graphy",
      },
      {
        question: "Can I receive international payments?",
        answer:
          "Yes, we have support for international payments. Subject to laws in specific countries and with specific payment methods",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Look no where else, ",
        highlight: false,
      },
      {
        text: "get started today",
        highlight: true,
      },
    ],
    description:
      "Activate your payments in one click and collect $ from your sales in no time.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Get paid now",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const ThirdPartySupportPageData: FeaturePageDataType = {
  seoMeta: {
    title: "Third party integrations to assist you in monetising your content - Graphy",
    description: "Support for third party integrations to set up your analytics, CRM, etc. Get started now.",
    canonicalPath: ROUTE_PATHS.FEATURES.ThirdPartySupport,
    countryCode: ""
  },
  otherOfferingsMeta: {
    name: "Third Party Support",
    description: "Seamlessly connect with preferred third-party tools.",
    image: OtherOfferingThirdPartyIntegrations,
    slug: FeaturePageSlugEnum.ThirdPartySupport,
    path: ROUTE_PATHS.FEATURES.ThirdPartySupport,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.ThirdPartySupport,
    },
    title: [
      {
        text: "Supercharge",
        highlight: true,
        lineBreak: true,
      },
      {
        text: "your business",
      },
    ],
    description: "Seamlessly connect with preferred third-party tools.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Link other apps",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        actionType: CtaActionType.BookDemo,
        text: "Book a Demo",
      },
    ],
    heroStatsProps: {
      text: "150,000+ creators using 3rd party integrations",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerThirdPartySupport,
      alt: "Courses",
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Integrate for ",
      },
      {
        text: "limitless possibilities",
        highlight: true,
      },
    ],
    description:
      "Seamless integrations with top tools, optimizing your business and enhancing learning",
    steps: [
      {
        text: "Powerful integrations",
        description:
          "Connect Graphy with leading tools like Zoom, Zoho CRM, Zapier and more",
        image: CardsThirdPartySupport1,
      },
      {
        text: "Streamlined workflow",
        description:
          "Automate tasks and enhance productivity with seamless integrations.",
        image: CardsThirdPartySupport2,
      },
      {
        text: "Flexibility & scalability",
        description:
          "Expand your business with integrations that support growth.",
        image: CardsThirdPartySupport3,
      },
    ],
  },
  infoAccordionSection: {
    title: [
      {
        text: "Connect with your favourite tools",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.SUBFEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Thirdpartysupport,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Link other apps",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.features_section,
        },
      },
    },
    commonImage: { src: InfoAccordionThirdPartySupport, alt: "" },
    data: [
      {
        title: "Zoom integration",
        description:
          "Conduct live classes and webinars seamlessly with Zoom integration.",
      },
      {
        title: "Zoho CRM integration",
        description:
          "Easily manage and nurture your leads with Zoho CRM integration.",
      },
      {
        title: "Email integration",
        description:
          "Effortlessly communicate with your learners using integrated email tools.",
      },
      {
        title: "Zapier integration",
        description:
          "Automate workflows and connect Graphy with thousands of other apps through Zapier.",
      },
      {
        title: "Other integrations",
        description:
          "Explore the platform today and discover the infinite possibilities",
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "Can you access any of my API authentication or account details?",
        answer:
          "All your personal data is stored as the local laws in your country. We compliant to most of the strictest privacy certifications in the world",
      },
      {
        question: "Can I integrate any custom platform",
        answer:
          "Yes, we allow integration with custom platform for some specific use cases by exposing some APIs and webhooks",
      },
      {
        question: "Do you provide any logs to these integrations?",
        answer: "No, we do not provide logs for activity in our integrations",
      },
      {
        question: "Is there any extra charge for integrations? ",
        answer:
          "No, we do not charge anything extra for integratiing third party platforms. Please note that the charges for third party platform will not be borne by us",
      },
      {
        question: "Can you add more integrations that I need?",
        answer: "Please submit your request in feedback.graphy.com",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "You've found the best,",
        highlight: false,
      },
      {
        text: " let's start",
        highlight: true,
      },
    ],
    description:
      "Seamlessly connect with preferred third-party tools and grow your business",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Link other apps",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
};

const AiAgent: FeaturePageDataType = {
  seoMeta: {
    title: "Launch Your Own AI Agents",
    description:
      "Meet your AI Agent — the smart assistant that sells courses, answers questions, and supports learners automatically across every page.",
    canonicalPath: ROUTE_PATHS.FEATURES.aiagent,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "AI Agent",
    description: "Meet Your AI Agent — Sell More, Support Better",
    image: OtherOfferingChatCommunity,
    slug: FeaturePageSlugEnum.aiagent,
    path: ROUTE_PATHS.FEATURES.aiagent,
    isNew: true,
  },
  // productHeroSectionProps: {
  //   heroPill: {
  //     category: HeroPillCategoryEnum_en.Products,
  //     subCategory: ProductsEnum_en.AiAgent,
  //   },
  //   title: [
  //     {
  //       text: "Meet Your AI Agent",
  //       lineBreak: true,
  //     },
  //     {
  //       text: "Sell More, Support Better",
  //       highlight: true,
  //     },
  //   ],
  //   description:
  //     "One smart assistant that guides visitors to purchase your products, answers learner questions, and works across every page — all powered by your AI brain.",
  //   ctas: [
  //     {
  //       type: ButtonTypeEnum.Primary,
  //       size: ButtonSizeEnum.Regular,
  //       text: "Activate Your Agent",
  //       actionType: CtaActionType.SignUp,
  //       amplitudeEvent: {
  //         eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
  //         eventProperties: {
  //           source: SignUpSourceEnum.hero,
  //         },
  // },
  //       queryParams: {
  //         destination: OnboardingDestinationEnum.Courses,
  //         skipOnboarding: false,
  //       },
  //     },
  //     {
  //       type: ButtonTypeEnum.Secondary,
  //       size: ButtonSizeEnum.Regular,
  //       text: "Book a demo",
  //       actionType: CtaActionType.BookDemo,
  //       amplitudeEvent: {
  //         eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
  //         eventProperties: {
  //           source: BookADemoSourceEnum.hero,
  //         },
  //       },
  //     },
  //   ],
  //   heroStatsProps: {
  //     text: "200,000+ happy creators",
  //     avatars: [
  //       {
  //         src: Avatar1,
  //         alt: "avatar1",
  //       },
  //       {
  //         src: Avatar2,
  //         alt: "avatar2",
  //       },
  //       {
  //         src: Avatar3,
  //         alt: "avatar3",
  //       },
  //     ],
  //   },
  //   coverImage: {
  //     src: getCDNURL().replace(/\/$/, '') + "/graphy-web/videos/Agent.mp4",
  //     alt: "AiAvatars",
  //     isVideo: true
  //   },
  // },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.AiAgent,
    },
    title: [
      {
        text: "Meet Your AI Agent",
        lineBreak: true,
      },
      {
        text: "Sell More, Support Better",
        highlight: true,
      },
    ],
    description:
      "One smart assistant that guides visitors to purchase your products, answers learner questions, and works across every page — all powered by your AI Brain.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Activate my AI Agent",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "200,000+ happy creators",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerAiAgent,
      alt: "AI Agent",
      isVideo: false
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Multiply Your Impact ",
        highlight: true,
      },
      {
        text: "Without Multiplying Your Hours",
        highlight: false,
      },
    ],
    description:
      "",
    steps: [
      {
        text: "Convert Visitors",
        description:
          "Your Agent helps people find the right course and get to checkout quickly.",
        image: CardsAiAgent1,
      },
      {
        text: "Support Learners",
        description:
          "Guides learners when they’re stuck, answers questions instantly, and keeps them on track.",
        image: CardsAiAgent2,
      },
      {
        text: "Works Everywhere",
        description:
          "Website, dashboard, and mobile app — your Agent is available 24/7.",
        image: CardsAiAgent3,
      },
    ],
  },
 
  infoAccordionSection: {
    title: [
      {
        text: "How AI Agent Becomes a Perfect Teammate",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Graphyassist,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Activate your AI Agent",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Courses,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "Always Available",
        description:
        "Your AI agent works around the clock — answering questions, converting leads, and supporting learners even when you’re offline.",  
        image: {
          src: agentWorks1,
          alt: "AiAvatars",
        },
      },
      {
        title: "Increases Your Sales",
        description:
          "Turn curious visitors into paying customers. The AI agent knows your offerings, handles objections, and nudges buyers toward checkout automatically.",
        image: {
          src: agentWorks2,
          alt: "AiAvatars",
        },
      },
      {
        title: "Supports Better",
        description:
          "Deliver instant, accurate responses to learner questions. With AI handling FAQs and common issues, every learner feels personally attended to.",
        image: {
          src: agentWorks3,
          alt: "AiAvatars",
        },
      },
      {
        title: "Optimizes Time and Cost",
        description:
          "Save hours of manual work and reduce the need for extra support staff. The AI agent scales your operations efficiently, cutting overhead while improving responsiveness.",
        image: {
          src: agentWorks4,
          alt: "AiAvatars",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information on selling courses, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "What is an AI Agent?",
        answer:
        "An AI Agent is your 24/7 assistant that answers questions, guides visitors to the right course, and helps learners solve issues instantly. It’s powered by your Brain, so it always gives accurate and consistent answers.",
      },
      {
        question:
          "Do I need to set it up manually?",
        answer: "No — once you update your Brain, your Agent is ready.",
      },
      {
        question:
          "Can I see what my Agent says?",
        answer:
          "Yes — you get full conversation logs.",
      },
      {
        question: "Can I control tone and topics?",
        answer:
          "Absolutely — everything is powered by your Brain content.",
      },
      {
        question: "How does Agent help me increase sales?",
        answer:
          "Your AI Agent can recommend the right course, answer pre-purchase questions, and guide visitors through the checkout process. This means fewer drop-offs, more completed purchases, and higher revenue",
      },
      {
        question: "Can an AIAgent handle learner support?",
        answer:
          "Yes! Once someone is inside your dashboard, the AI Agent becomes a support assistant. It troubleshoots login issues, explains how to access content, answers payment questions, and reduces the number of tickets you need to handle manually.",
      },
      {
        question:
          "Do I need technical skills to set up my Graphy AI Agent?",
        answer:
          "No technical skills needed. Your AI Agent is ready to go as soon as you update your Brain with FAQs, topics, and instructions. Deployment across your site, dashboard, and app is automatic.",
      },
      {
        question:
          "Can I control what my AI Agent says?",
        answer:
          "Absolutely. You decide what goes into your Brain — your policies, tone, and content — and your AI Agent will follow it. You can update it anytime to refine answers or add new information.",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Activate Your ",
        highlight: false,
      },
      {
        text: "AI Agent Today",
        highlight: true,
      },
    ],
    description:
    "Let it start selling and supporting your learners for you.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Activate my AI Agent",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
            queryParams: {
              destination: OnboardingDestinationEnum.Courses,
              skipOnboarding: false,
            },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
 };

 const AiBrain: FeaturePageDataType = {
  seoMeta: {
    title: "Build Your AI Brain: Centralize, Train & Power All Your Graphy AI Products",
    description:
      "Create a central AI Brain that learns from your content and powers your AI suite which manages your business while you focus on creating.",
    canonicalPath: ROUTE_PATHS.FEATURES.aibrain,
    countryCode: "",
  },
  otherOfferingsMeta: {
    name: "AI Brain",
    description: "Create a central AI Brain that learns from your content and powers your AI suite which manages your business while you focus on creating.",
    image: OtherOfferingChatCommunity,
    slug: FeaturePageSlugEnum.aibrain,
    path: ROUTE_PATHS.FEATURES.aibrain,
    isNew: true,
  },
  featureHeroSectionProps: {
    heroPill: {
      category: HeroPillCategoryEnum_en.Features,
      subCategory: FeaturesEnum_en.AiBrain,
    },
    title: [
      {
        text: "Build your",
        lineBreak: true,
      },
      {
        text: "AI Brain",
        highlight: true,
      },
    ],
    description:
    "One central AI Brain that learns from your content, understands your personality, and powers every interaction across your site and app.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Create my AI Brain",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.hero,
          },
        },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.hero,
          },
        },
      },
    ],
    heroStatsProps: {
      text: "54,000+ Avatars created",
      avatars: [
        {
          src: Avatar1,
          alt: "avatar1",
        },
        {
          src: Avatar2,
          alt: "avatar2",
        },
        {
          src: Avatar3,
          alt: "avatar3",
        },
      ],
    },
    coverImage: {
      src: BannerAiBrain,
      alt: "AI Brain",
      isVideo: false
    },
  },
  testimonyCarouselSectionProps: {
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  featureCardsSectionProps: {
    title: [
      {
        text: "Unlock Your Content’s ",
        highlight: true,
      },
      {
        text: "Full Intelligence With AI Brain",
        highlight: false,
      },
    ],
    description:
      "",
    steps: [
      {
        text: "One Brain, Endless Possibilities",
        description:
          "Store every piece of your knowledge in one intelligent system that powers all your AI products and features.",
        image: CardsAiBrain1,
      },
      {
        text: "Built For Scale",
        description:
          "Add new content anytime–website links, YouTube videos, social posts, course content, and Q&As and your Brain instantly updates all your Graphy AI products.",
        image: CardsAiBrain2,
      },
      {
        text: "Structured For Action",
        description:
          "Your AI Brain understands context and relationships between topics, delivering the right information to your Agent and Avatar.",
        image: CardsAiBrain3,
      },
    ],
  },
 
  infoAccordionSection: {
    title: [
      {
        text: "Connect, Educate, Grow",
      },
    ],
    amplitudeEvent: {
      eventName: LANDING_PAGE_EVENTS.PRODUCT_FEATURE_DETAIL_EXPANDED.LABEL,
    },
    section: InfoAccFeatSecForAmpEnum.Aibrain,
    cta: {
      type: ButtonTypeEnum.Secondary,
      size: ButtonSizeEnum.Regular,
      text: "Build Your AI Brain",
      actionType: CtaActionType.SignUp,
      amplitudeEvent: {
        eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
        eventProperties: {
          source: SignUpSourceEnum.products_section,
        },
      },
      queryParams: {
        destination: OnboardingDestinationEnum.Courses,
        skipOnboarding: false,
      },
    },
    data: [
      {
        title: "One source of truth",
        description:
        "Upload your social media links, course notes, lessons, and FAQs..",  
        image: {
          src: aibraininfoaccordian1,
          alt: "AI Brain",
        },
      },
      {
        title: "Context that sells and supports",
        description:
        "Your AI Brain understands your tone, intent, and ideas — making your AI Agent and Avatar sound exactly like you, building trust and driving more conversions.",
        image: {
          src: aibraininfoaccordian2,
          alt: "AI Brain",
        },
      },
      {
        title: "Knowledge that works for you",
        description:
          "Deliver faster support, instant learning materials, and give yourself more time to create instead of manage.",
        image: {
          src: aibraininfoaccordian3,
          alt: "AI Brain",
        },
      },
      {
        title: "Always up-to-date, always on-brand",
        description:
          "Upload new videos, blogs, or lessons once or in parts — your AI Brain retrains and updates your entire ecosystem.",
        image: {
          src: aibraininfoaccordian4,
          alt: "AI Brain",
        },
      },
    ],
    type: InfoAccordionTypeEnum.MediaFirst,
  },
  successStoriesMarqueeSectionProps: {
    title: [
      {
        text: "Success Stories of Our Partners",
      },
    ],
    successStories: [
      // will be infered from creator-stories.data.ts
    ],
  },
  faqSectionProps: {
    title: "FAQs",
    description:
      "Explore our help center for detailed information on selling courses, troubleshooting guides, and more",
    cta: CtaVisitHelpCentre_en,
    faqs: [
      {
        question:
          "Do I need to retrain my AI Brain often?",
        answer:
        "You don’t need to keep training your AI Brain for it to function well but you will have to train it with new content that you create or publish.",
      },
      {
        question:
          "Where is my data stored?",
        answer: "Your data is encrypted, secure, and only used to build your private AI Brain.",
      },
      {
        question:
          "What type of media can I add to my AI Brain?",
        answer:
          "You can add website links, YouTube videos, social posts, course content, live-class recordings, PDFs, Q&As, and text snippets — your AI Brain will learn from them all.",
      },
      {
        question: "How does Agent and Avatar decide which assets to refer to while answering learner's questions?",
        answer:
          "They analyze context and intent in real time, then pull answers from the most relevant parts of your AI Brain’s content.",
      },
    ],
  },
  featureCTASectionProps: {
    title: [
      {
        text: "Train Your ",
        highlight: false,
      },
      {
        text: "AI Brain",
        highlight: true,
      },
    ],
    description:
    "Power your business with AI through your AI Brain.",
    ctas: [
      {
        type: ButtonTypeEnum.Primary,
        size: ButtonSizeEnum.Regular,
        text: "Launch Your AI Brain",
        actionType: CtaActionType.SignUp,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.SIGN_UP_TAPPED.LABEL,
          eventProperties: {
            source: SignUpSourceEnum.body_end,
          },
        },
            queryParams: {
              destination: OnboardingDestinationEnum.Courses,
              skipOnboarding: false,
            },
      },
      {
        type: ButtonTypeEnum.Secondary,
        size: ButtonSizeEnum.Regular,
        text: "Book a Demo",
        actionType: CtaActionType.BookDemo,
        amplitudeEvent: {
          eventName: LANDING_PAGE_EVENTS.BOOK_DEMO_TAPPED.LABEL,
          eventProperties: {
            source: BookADemoSourceEnum.bodyEnd,
          },
        },
      },
    ],
  },
 };


export const featurePagesData_en: FeaturePageDataType[] = [
  WebsiteBuilderPageData,
  MobileAppPageData,
  MarketingToolsPageData,
  ChatCommunityPageData,
  SecureVideoStreamingPageData,
  IntegratePaymentGatewayPageData,
  ThirdPartySupportPageData,
  AiAgent,
  AiBrain,
];
